import React from 'react';
import { Collapse, Nav, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Button,  Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import './NavMenu.scss';
import { LoginMenu } from '../../Authentication/LoginMenu/LoginMenu';
import AuthenticatedMenu from '../../Authentication/AuthenticatedMenu/AuthenticatedMenu';
import { logout, getLoggedinUser } from '../../../../Redux/Actions/EndUser/AuthActions';
import { auth } from '../../../../services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class NavMenu extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		  isOpen: false,
		  authenticated: false,
		  modalIsOpen: false,
		  pathName:''
		};
		this.toggle = this.toggle.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
	}

	componentDidUpdate(prevProps, prevState) {
	  if (prevProps.authenticated !== this.props.authenticated) {
		this.setState({authenticated: this.props.authenticated});
	  }
	}

	toggle() {
	  this.setState({ isOpen: !this.state.isOpen });
	}

	toggleModal() {
		this.setState({
		  modalIsOpen: !this.state.modalIsOpen
		});
	}

	navItemTrigger() {
		if(this.state.isOpen) {
			this.toggle();
		}
	}

	logoutClick(event) {
		logout();
		event.preventDefault();
	}

	GetNav() {
		return (
			<header className="app-header">
				<div className="nav-wrapper">
					<Navbar className="primary" light expand="lg">
						<a className="logo-link" href="https://tscra.org/">
							<img src="/images/tscra-logo-round.webp" className="logo" alt="TSCRA Membership" />
						</a>

						<NavbarToggler onClick={this.toggle} />

						<Collapse isOpen={this.state.isOpen} navbar className="primary-nav">
							<Nav className="navList" navbar>
								<NavItem onClick={() => { this.navItemTrigger() }}>
									<a className=" nav-link" href="https://tscra.org/">Home</a>
								</NavItem>
								<NavItem onClick={() => { this.navItemTrigger() }}>
									<a className=" nav-link" href="https://tscra.org/who-we-are/">Who We Are</a>
								</NavItem>
								<NavItem onClick={() => { this.navItemTrigger() }}>
									<a className=" nav-link" href="https://tscra.org/what-we-do/">What We Do</a>
								</NavItem>
								<NavItem onClick={() => { this.navItemTrigger() }}>
									<a className=" nav-link" href="https://tscra.org/information/events/">Events</a>
								</NavItem>

								<NavItem onClick={() => { this.navItemTrigger() }}>
									{this.props.authenticated ?
											<NavLink tag={RouterNavLink}
												className={this.props.pathname === '/dashboard' ? 'active-navlink' : ''}
												to="/dashboard">Member Center</NavLink>
										:
											<NavLink tag={RouterNavLink}
												className={this.props.pathname === '/' ? 'active-navlink' : ''}
												to="/">Member Center</NavLink>
									}
									
									{this.props.authenticated ?
										<ul>
											<NavItem onClick={() => { this.navItemTrigger() }}>
												<NavLink tag={RouterNavLink}
													className={this.props.pathname === '/dashboard' ? 'active-navlink' : ''}
													to="/dashboard">Login/Renew</NavLink>
											</NavItem>
											<NavItem onClick={() => { this.navItemTrigger() }}>
												<NavLink tag={RouterNavLink}
													className={this.props.pathname === '/memberdiscount' ? 'active-navlink' : ''}
													to="/memberdiscount">Member Discounts</NavLink>
											</NavItem>
											<NavItem onClick={() => { this.logoutClick() }}>
												<a href="#" className="nav-link">Logout</a>
											</NavItem>
										</ul>
									:
										<ul>
											<NavItem onClick={() => { this.navItemTrigger() }}>
												<NavLink tag={RouterNavLink}
													className={this.props.pathname === '/accountcreate' ? 'active-navlink' : ''}
													to="/accountcreate">Join</NavLink>
											</NavItem>
											<NavItem onClick={() => { this.navItemTrigger() }}>
												<NavLink tag={RouterNavLink}
													className={this.props.pathname === '/login' ? 'active-navlink' : ''}
													to="/login">Login/Renew</NavLink>
											</NavItem>
											<NavItem>
												<a className=" nav-link" href="https://tscra.org/membership-portal-instruction/">Instructions</a>
											</NavItem>
										</ul>
									}
								</NavItem>
								
								<NavItem onClick={() => { this.navItemTrigger() }}>
									<a className=" nav-link" target="_blank" href="https://cattle-raisers-trading-co.myshopify.com/">TSCRA Store</a>
								</NavItem>

                                {auth.isInRole('INTERNAL') ? this.GetAdminHomeNavItem() : null}
                            </Nav>
						</Collapse>
					</Navbar>

					{/*<div className="utility">
						{this.props.authenticated ?
							<AuthenticatedMenu />
							:
							<Nav className="btn-margin-r" navbar>
								<NavItem>
									<Button className="btnPrimary margin" onClick={this.toggleModal}><i className="fas fa-sign-in-alt"></i> Login</Button>
								</NavItem>
							</Nav>
						}
						<Navbar className="search">
								<FontAwesomeIcon icon={["far", "magnifying-glass"]} />
								<FontAwesomeIcon icon="coffee" />
							<Button className="btnPrimary margin" onClick={this.toggleModal}>
							</Button>
						</Navbar>
					</div>*/}

					<Modal isOpen={this.state.modalIsOpen} toggle={this.toggleModal} className={this.props.className}>
						<ModalHeader toggle={this.toggleModal}>Login</ModalHeader>
                        <ModalBody>
                            <LoginMenu toggle={this.toggleModal} />
						</ModalBody>
        			</Modal>
				</div>
			</header>
		);
	}

	GetLoginMenu() {
		return (
			<Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={this.state.isOpen} navbar>
				<LoginMenu toggle={this.toggleModal}/>
			</Collapse>
		);
	}

	GetHomeNavItem() {
		if (this.props.authenticated) {
			return (
				<NavItem onClick={()=>{this.navItemTrigger()}}>
					<NavLink tag={RouterNavLink}
					className= {this.props.pathname === '/dashboard' ? 'active-navlink' : ''}
					to="/dashboard">
						Member Center
					</NavLink>
				</NavItem>
			);
		}
		return null;
	}
	GetAdminHomeNavItem()
	{

        var permissions = auth.getPermissions();

        var permissionValue = permissions[0].value;

        if (permissionValue === 'Admin') {
            if (this.props.authenticated) {
                return (
                    <NavItem onClick={() => { this.navItemTrigger() }}>
                        <NavLink tag={RouterNavLink}
                            className={this.props.pathname === '/admin/users' ? 'active-navlink' : ''}
                            to='/admin/users'>
                            Admin
					    </NavLink>
                    </NavItem>
                );
            };
        } else if (permissionValue === 'Events') {
            if (this.props.authenticated) {
                return (
                    <NavItem onClick={() => { this.navItemTrigger() }}>
                        <NavLink tag={RouterNavLink}
                            className={this.props.pathname === '/admin/events' ? 'active-navlink' : ''}
                            to='/admin/events'>
                            Admin
					    </NavLink>
                    </NavItem>
                );
            }
        } else if (permissionValue === 'Accounting') {
            if (this.props.authenticated) {
                return (
                    <NavItem onClick={() => { this.navItemTrigger() }}>
                        <NavLink tag={RouterNavLink}
                            className={this.props.pathname === '/admin/purchaseandrenewals' ? 'active-navlink' : ''}
                            to='/admin/purchaseandrenewals'>
                            Admin
					    </NavLink>
                    </NavItem>
                );
            }
        } else if (permissionValue === 'Inventory') {
            if (this.props.authenticated) {
                return (
                    <NavItem onClick={() => { this.navItemTrigger() }}>
                        <NavLink tag={RouterNavLink}
                            className={this.props.pathname === '/admin/inventory' ? 'active-navlink' : ''}
                            to='/admin/inventory'>
                            Admin
					    </NavLink>
                    </NavItem>
                );
            }
        } else if (permissionValue === 'Membership') {
            if (this.props.authenticated) {
                return (
                    <NavItem onClick={() => { this.navItemTrigger() }}>
                        <NavLink tag={RouterNavLink}
                            className={this.props.pathname === '/admin/membership' ? 'active-navlink' : ''}
                            to='/admin/membership'>
                            Admin
					    </NavLink>
                    </NavItem>
                );
            }
        } else if (permissionValue === '"Subscription"') {
            if (this.props.authenticated) {
                return (
                    <NavItem onClick={() => { this.navItemTrigger() }}>
                        <NavLink tag={RouterNavLink}
                            className={this.props.pathname === '/admin/subscription' ? 'active-navlink' : ''}
                            to='/admin/subscription'>
                            Admin
					    </NavLink>
                    </NavItem>
                );
            }
        } else if (permissionValue === 'Field') {
            if (this.props.authenticated) {
                return (
                    <NavItem onClick={() => { this.navItemTrigger() }}>
                        <NavLink tag={RouterNavLink}
                            className={this.props.pathname === '/admin/field' ? 'active-navlink' : ''}
                            to='/admin/field'>
                            Admin
					    </NavLink>
                    </NavItem>
                );
            }
		}
		else if (permissionValue === 'Donation') {
            if (this.props.authenticated) {
                return (
                    <NavItem onClick={() => { this.navItemTrigger() }}>
                        <NavLink tag={RouterNavLink}
                            className={this.props.pathname === '/admin/donations' ? 'active-navlink' : ''}
                            to='/admin/donations'>
                            Admin
					    </NavLink>
                    </NavItem>
                );
            }
        }
	}

	render() {
		let nav = this.GetNav();
		return <div> {nav} </div>;
	}
}


function mapStateToProps(state) {
	const { authenticating, authenticated } = state.authentication;
	var pathname = "/";
	if (state.routing && state.routing.location){
	  pathname = state.routing.location.pathname.trim();
	  pathname = pathname.indexOf('?') > -1 ? pathname.split('?')[0] : pathname;
	}
	return {
		authenticating,
		authenticated,
		pathname
	};
  }
  export default withRouter(connect(mapStateToProps)(NavMenu));
